import * as React from 'react';
import { makeStyles, tokens, mergeClasses } from '@fluentui/react-components';
type Props = React.HTMLAttributes<HTMLDivElement> & { kind: 'bot'|'user' };
const useStyles = makeStyles({
  base:{ 
    paddingTop: '12px',
    paddingBottom: '12px',
    paddingLeft: '16px',
    paddingRight: '16px', 
    borderRadius: 'var(--radius-card, 10px)', 
    boxShadow: tokens.shadow4, 
    position:'relative',
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
    transition: 'all 0.2s ease-in-out',
    border: '1px solid rgba(0, 0, 0, 0.1)',
    '&:hover': {
      transform: 'translateY(-1px)',
      boxShadow: tokens.shadow8
    },
    '&:focus-visible': {
      outline: 'var(--focus-ring-width, 4px) solid var(--focus-ring-color, var(--brand-60))',
      outlineOffset: 'var(--focus-ring-offset, 2px)',
      boxShadow: tokens.shadow8
    }
  },
  bot:{ 
    background: 'var(--brand-answer-bg, var(--neutral-0))',
    border: '1px solid rgba(0, 0, 0, 0.1)',
    fontSize: 'var(--message-text-size, 14px)',
    fontFamily: 'var(--font-family-base, "Segoe UI", "Helvetica Neue", Arial, sans-serif)',
    fontWeight: 'var(--message-text-weight, 400)',
    fontStyle: 'var(--message-text-style, normal)',
    lineHeight: '1.5',
    color: tokens.colorNeutralForeground1
  },
  user:{ 
    background: 'var(--brand-question-bg, #006BA6)',
    color: 'var(--text-on-brand, #FFFFFF)', 
    marginLeft:'auto',
    maxWidth: '100%', // Allow full width within the 50% container
    fontSize: 'var(--question-text-size, 14px)',
    fontFamily: 'var(--font-family-base, "Segoe UI", "Helvetica Neue", Arial, sans-serif)',
    fontWeight: 'var(--question-text-weight, 400)',
    fontStyle: 'var(--question-text-style, normal)',
    lineHeight: '1.5',
    border: '1px solid rgba(0, 0, 0, 0.1)',
    '@media (max-width: 768px)': {
      maxWidth: '100%'
    }
  },
});
export const Bubble = React.forwardRef<HTMLDivElement, Props>(({ kind, className, children, ...rest }, ref) => {
  const s = useStyles();
  const cls = mergeClasses(s.base, s[kind], className);
  
  return (
    <div 
      ref={ref}
      className={cls} 
      role="article"
      tabIndex={0}
      {...rest}
    >
      {children}
    </div>
  );
});
